// extracted by mini-css-extract-plugin
export default {"wrapper":"wo","form":"xo","circle":"yo","success":"zo","button":"Ao"};